/* CREU — Piezas de una combinación (snippets/creu-pack-pieces.liquid).
 *
 * Cada pieza trae en JSON sus "caras": el producto y sus hermanos de otro metal
 * (tras el split, oro y plata son productos distintos). Aquí se elige cara y
 * opciones, se recalcula el precio de la pieza y el total (suma de piezas ×
 * cantidad) y se añaden al carrito: una pieza o todas a la vez en una sola
 * llamada a /cart/add.js. No existe precio de pack.
 *
 * Delegado sobre `document` y cargado una vez por página. Lo que llegue más
 * tarde (la vista inspo pinta el pack al abrirlo) se prepara con
 * `window.CreuPack.init(contenedor)`. */
(function () {
  if (window.CreuPack) return;

  // Textos de window.CreuT (layout); el literal es el fallback en español.
  var tr = function (k, fallback) { return (window.CreuT && window.CreuT[k]) || fallback; };

  var METALES = ['oro', 'plata', 'acero'];
  var ETIQUETA_METAL = {
    oro: ['creu.tienda.finish_gold', 'Oro'],
    plata: ['creu.tienda.finish_silver', 'Plata'],
    acero: ['creu.tienda.finish_steel', 'Acero'],
  };

  // Mismo formato que el resto del tema: `money_without_currency` + "€" (58,00€).
  function formatear(cents) {
    var partes = (cents / 100).toFixed(2).split('.');
    return partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + partes[1] + ' €';
  }

  function metalPreferido() {
    // ?acabado=oro|rodio llega desde los círculos de la tarjeta del pack (Alba,
    // 20-10-2026): se aplica a todas las piezas y queda guardado como preferencia.
    var q = null;
    try { q = new URLSearchParams(location.search).get('acabado'); } catch (e) {}
    if (q === 'oro' || q === 'rodio') {
      try { if (window.CreuFinish && window.CreuFinish.set) window.CreuFinish.set(q); } catch (e) {}
      return q === 'rodio' ? 'plata' : 'oro';
    }
    var f = window.CreuFinish && window.CreuFinish.get ? window.CreuFinish.get() : 'oro';
    return f === 'rodio' ? 'plata' : 'oro';
  }

  // Una opción es "de metal" si todos sus valores son metales (Material=Oro…).
  // Tras el split esa opción queda con un solo valor: se elige con los círculos.
  function esOpcionMetal(cara, idx) {
    var vals = cara.variants.map(function (v) { return String(v.options[idx] || '').toLowerCase(); });
    return vals.length > 0 && vals.every(function (v) {
      return /oro|dorado|gold|plata|plateado|silver|rodio|acero/.test(v);
    });
  }

  function variante(cara, sel) {
    var mejor = null;
    for (var i = 0; i < cara.variants.length; i++) {
      var v = cara.variants[i];
      var ok = cara.options.every(function (nombre, idx) {
        return esOpcionMetal(cara, idx) || sel[nombre] == null || v.options[idx] === sel[nombre];
      });
      if (ok && (!mejor || (v.available && !mejor.available))) mejor = v;
    }
    return mejor || cara.variants[0];
  }

  function boton(texto, pulsado, attrs) {
    var b = document.createElement('button');
    b.type = 'button';
    b.textContent = texto;
    b.setAttribute('aria-pressed', pulsado ? 'true' : 'false');
    for (var k in attrs) b.setAttribute(k, attrs[k]);
    return b;
  }

  function pintarPieza(pieza) {
    var st = pieza._creu;
    var cara = st.caras[st.cara];
    var v = variante(cara, st.sel);
    st.variante = v;

    var sel = pieza.querySelector('[data-piece-selectors]');
    sel.textContent = '';

    if (st.caras.length > 1) {
      var fila = document.createElement('div');
      fila.className = 'pack-items__dots';
      fila.setAttribute('role', 'group');
      fila.setAttribute('aria-label', tr('creu.ficha.finish', 'Acabado'));
      st.caras.forEach(function (c, i) {
        var m = METALES.indexOf(c.metal) >= 0 ? c.metal : 'oro';
        var b = boton('', i === st.cara, {
          class: 'pack-items__dot creu-pack__metal creu-pack__metal--' + m + (i === st.cara ? ' pack-items__dot--active' : ''),
          'aria-label': ETIQUETA_METAL[m] ? tr(ETIQUETA_METAL[m][0], ETIQUETA_METAL[m][1]) : c.metal,
          'data-cara': i,
        });
        fila.appendChild(b);
      });
      sel.appendChild(fila);
    }

    cara.options.forEach(function (nombre, idx) {
      if (esOpcionMetal(cara, idx)) return;
      var valores = [];
      cara.variants.forEach(function (x) { if (valores.indexOf(x.options[idx]) < 0) valores.push(x.options[idx]); });
      if (valores.length < 2) return;
      var grupo = document.createElement('div');
      grupo.className = 'pack-items__text-options';
      grupo.setAttribute('role', 'group');
      grupo.setAttribute('aria-label', nombre);
      valores.forEach(function (val) {
        var activo = v.options[idx] === val;
        grupo.appendChild(boton(val, activo, {
          class: 'pack-items__text-btn' + (activo ? ' pack-items__text-btn--active' : ''),
          'data-opcion': nombre,
          'data-valor': val,
        }));
      });
      sel.appendChild(grupo);
    });

    var img = pieza.querySelector('[data-piece-img]');
    var src = v.img || cara.img;
    if (img && src) { img.src = src; img.removeAttribute('srcset'); }
    var enlace = pieza.querySelector('[data-piece-link]');
    if (enlace) enlace.href = cara.url + '?variant=' + v.id;
    pieza.querySelector('[data-piece-price]').textContent = formatear(v.price);

    var add = pieza.querySelector('[data-piece-add]');
    add.disabled = !v.available;
    add.textContent = v.available ? tr('creu.tienda.add_to_cart', 'Añadir al carrito') : tr('creu.tienda.sold_out', 'Agotado');
  }

  function pintarTotal(pack) {
    var total = 0;
    var agotadas = 0;
    pack.querySelectorAll('[data-creu-pack-piece]').forEach(function (p) {
      var st = p._creu;
      if (!st) return;
      total += st.variante.price * st.qty;
      if (!st.variante.available) agotadas++;
    });
    var t = pack.querySelector('[data-pack-total]');
    if (t) t.textContent = formatear(total);
    var b = pack.querySelector('[data-pack-add-all]');
    if (b) b.disabled = agotadas === pack.querySelectorAll('[data-creu-pack-piece]').length;
  }

  function init(raiz) {
    (raiz || document).querySelectorAll('[data-creu-pack]').forEach(function (pack) {
      if (pack._creuListo) return;
      pack._creuListo = true;
      var pref = metalPreferido();
      // Alba 20-10-2026: si la combinación mezcla acabados a propósito (Duo Duna,
      // uno en oro y otro en rodio), cada pieza sale en el suyo. Si todas son del
      // mismo acabado, manda la preferencia de la clienta.
      var propios = [];
      pack.querySelectorAll('[data-creu-pack-piece]').forEach(function (pieza) {
        try { var cs = JSON.parse(pieza.querySelector('[data-faces]').textContent); if (cs && cs[0]) propios.push(cs[0].metal); } catch (e) {}
      });
      var mixta = propios.some(function (m) { return m !== propios[0]; });
      pack.querySelectorAll('[data-creu-pack-piece]').forEach(function (pieza) {
        var caras;
        try { caras = JSON.parse(pieza.querySelector('[data-faces]').textContent); } catch (e) { return; }
        if (!caras || !caras.length) return;
        var cara = 0;
        if (!mixta) caras.forEach(function (c, i) { if (c.metal === pref) cara = i; });
        pieza._creu = {
          caras: caras,
          cara: cara,
          sel: {},
          qty: parseInt(pieza.getAttribute('data-qty'), 10) || 1,
        };
        pintarPieza(pieza);
      });
      pintarTotal(pack);
    });
  }

  function avisar(pack, texto) {
    var s = pack.querySelector('[data-pack-status]');
    if (s) s.textContent = texto;
  }

  async function anadir(pack, items, boton) {
    if (!items.length) return false;
    boton.disabled = true;
    try {
      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      });
      if (!r.ok) throw new Error('add_' + r.status);
      var cart = await fetch('/cart.js').then(function (x) { return x.json(); });
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: cart, sourceId: 'creu-pack', data: { itemCount: cart.item_count, variantId: items[items.length - 1].id } };
      document.dispatchEvent(ev);
      if (window.CreuCart) {
        await window.CreuCart.refresh();
        window.CreuCart.open();
      }
      return true;
    } catch (e) {
      avisar(pack, tr('creu.packs.add_error', 'No se ha podido añadir. Vuelve a intentarlo.'));
      return false;
    } finally {
      boton.disabled = false;
    }
  }

  document.addEventListener('click', async function (e) {
    var pack = e.target.closest('[data-creu-pack]');
    if (!pack) return;
    var pieza = e.target.closest('[data-creu-pack-piece]');
    var st = pieza && pieza._creu;

    var b = e.target.closest('[data-cara]');
    if (b && st) {
      st.cara = parseInt(b.getAttribute('data-cara'), 10);
      pintarPieza(pieza);
      pintarTotal(pack);
      return;
    }
    b = e.target.closest('[data-opcion]');
    if (b && st) {
      st.sel[b.getAttribute('data-opcion')] = b.getAttribute('data-valor');
      pintarPieza(pieza);
      pintarTotal(pack);
      return;
    }
    b = e.target.closest('[data-piece-add]');
    if (b && st && st.variante.available) {
      if (await anadir(pack, [{ id: st.variante.id, quantity: st.qty }], b)) avisar(pack, tr('creu.packs.piece_added', 'Pieza añadida al carrito.'));
      return;
    }
    b = e.target.closest('[data-pack-add-all]');
    if (b) {
      var items = [];
      var fuera = [];
      pack.querySelectorAll('[data-creu-pack-piece]').forEach(function (p) {
        if (!p._creu) return;
        if (p._creu.variante.available) items.push({ id: p._creu.variante.id, quantity: p._creu.qty });
        else fuera.push(p._creu.caras[p._creu.cara].title);
      });
      if (await anadir(pack, items, b)) {
        // Admite el placeholder literal o '[pieces]' (por si CreuT lo pinta con | t: pieces: '[pieces]').
        avisar(pack, fuera.length
          ? tr('creu.packs.set_added_except', 'Añadida la combinación salvo {{ pieces }} (agotada en este acabado).')
              .replace(/\{\{\s*pieces\s*\}\}|\[pieces\]/, fuera.join(', '))
          : tr('creu.packs.set_added', 'Combinación añadida al carrito.'));
      }
    }
  });

  window.CreuPack = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
